import type { Card } from '@/features/dashboard/api/schemas'
import { formatLike, toFigure } from '@/features/dashboard/format/figure'
import { formatChange } from '@/features/dashboard/format/format'

/** A card's latest value and change, e.g. "€12.5M, +4% on the previous period". */
export const valueSummary = (card: Card): string | null => {
  const figure = toFigure(card)
  if (!figure) return null
  const change =
    figure.fraction === null
      ? ''
      : `, ${formatChange(figure.fraction)} on the previous period`
  return `${formatLike(figure, figure.value)}${change}`
}

/** A chart's text alternative: the card's name, latest value and change. */
export const chartSummary = (card: Card): string => {
  const summary = valueSummary(card)
  return summary === null ? card.name : `${card.name}: ${summary}`
}
